// src/store.jsx

import { createStore, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // default storage for web
import rootReducer from "./rootReducer";

// Configure persist
const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['profile', 'getOrganiserEvent'] 
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer, applyMiddleware(thunk));
export const persistor = persistStore(store);

export default store;
